import React, { useState, useRef, useEffect, Component, useMemo, useReducer, useCallback, forwardRef, useImperativeHandle, Fragment } from 'react';
import { Button, ContentContainer, tokens, utils, SectionPage, Heading, TableContainer, Table, TableHeader, IconClose, IconMenu, FormHeader, IconChevronUp, IconChevronDown, Input, FormCheckbox, ErrorSystemPage, InPageAlert, IconUpload, Fieldset } from '@snsw/react-component-library';
import styled, { css, createGlobalStyle } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var jsxDevRuntime = {exports: {}};

var reactJsxDevRuntime_production_min = {};

/**
 * @license React
 * react-jsx-dev-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxDevRuntime_production_min;

function requireReactJsxDevRuntime_production_min () {
	if (hasRequiredReactJsxDevRuntime_production_min) return reactJsxDevRuntime_production_min;
	hasRequiredReactJsxDevRuntime_production_min = 1;
var a=Symbol.for("react.fragment");reactJsxDevRuntime_production_min.Fragment=a;reactJsxDevRuntime_production_min.jsxDEV=void 0;
	return reactJsxDevRuntime_production_min;
}

var reactJsxDevRuntime_development = {};

/**
 * @license React
 * react-jsx-dev-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxDevRuntime_development;

function requireReactJsxDevRuntime_development () {
	if (hasRequiredReactJsxDevRuntime_development) return reactJsxDevRuntime_development;
	hasRequiredReactJsxDevRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React$1 = React;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {
	    if (source !== undefined) {
	      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	      var lineNumber = source.lineNumber;
	      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	    }

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum(source);

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev

	var jsxDEV$1 =  jsxWithValidation ;

	reactJsxDevRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxDevRuntime_development.jsxDEV = jsxDEV$1;
	  })();
	}
	return reactJsxDevRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxDevRuntime.exports = requireReactJsxDevRuntime_production_min();
} else {
  jsxDevRuntime.exports = requireReactJsxDevRuntime_development();
}

var jsxDevRuntimeExports = jsxDevRuntime.exports;

const StyledWrapper$1 = styled.div`
  color: red;
`;

const AMSButton = () => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledWrapper$1, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Button, { children: "AMS button" }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/AMSButton/index.tsx",
  lineNumber: 7,
  columnNumber: 5
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/AMSButton/index.tsx",
  lineNumber: 6,
  columnNumber: 3
}, globalThis);

const StyledPageTitle = styled(ContentContainer)`
  background-color: ${tokens.colors.grey.iceBlue};

  padding: ${tokens.spacing.sm}px 0;

  ${utils.getBreakpoint.md`
  padding: ${tokens.spacing.md}px 0;
`}

  ${utils.getBreakpoint.lg`
padding: ${tokens.spacing.lg}px 0;
`}
`;

const PageTitle = ({ title }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledPageTitle, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Heading, { level: 2, children: title }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/pageTitle/index.tsx",
  lineNumber: 8,
  columnNumber: 7
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/pageTitle/index.tsx",
  lineNumber: 7,
  columnNumber: 5
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/pageTitle/index.tsx",
  lineNumber: 6,
  columnNumber: 3
}, globalThis);

const colours = {
  backgrounds: {
    error: "#f4dbe1",
    success: "#e5f6e6",
    warning: "#fcefe6",
    info: "#eaedf4",
    infoVariant: "#D7153A",
    infoDark: "#333333",
    infoLight: "#dee3e5",
    disabled: "#f4f7f9",
    disabledVariant: "#333333",
    selected: "#f4f7f9",
    active: "#002664",
    activeLight: "#2e5299",
    activeSuperLight: "#e0e4e6",
    inactive: "#9194a1",
    modal: "#333333db",
    default: "#fff",
    shadow: "#00000036",
    highlight: "#2e5299",
    modalDark: "#000",
    warningDark: "#dc5800",
    button: "#f9fdff"
  },
  borders: {
    error: "#b81237",
    success: "#00a908",
    warning: "#dc5800",
    info: "#2e5299",
    disabled: "#646974",
    disabledLight: "#dee3e5",
    focus: "#2e5299",
    active: "#242934",
    activeLight: "#646974",
    activeSuperLight: "#929fa4",
    activeLink: "#002664",
    activeDark: "#000",
    selected: "#d7153a",
    dark: "#9194a1",
    default: "#fff",
    button: "#c4d0d6",
    hover: "#deeaf0"
  },
  text: {
    body: "#242934",
    link: "#2e5299",
    disabled: "#646974",
    error: "#b81237",
    default: "#ffffff",
    primary: "#D7153A",
    active: "#002664"
  },
  primary: {
    base: "#002664",
    light: "#2e5299"
  },
  secondary: {
    base: "#d7153a"
  },
  error: {
    base: "#b81237",
    light: "#FD4646"
  },
  warning: {
    base: "#dc5800"
  },
  neutral: {
    base: "#9194a1",
    dark: "#646974",
    darker: "#242934",
    darkest: "#000000",
    light: "#dee3e5",
    lighter: "#ecf1f3",
    lightest: "#f4f7f9",
    xLight: "#ffffff"
  },
  other: {
    base: "#333"
  },
  success: {
    base: "#00a908"
  },
  grey: {
    darkGrey: "#242934",
    shuttle: "#646974",
    geyser: "#dee3e5",
    mystic: "#ecf1f3",
    iceBlue: "#f4f7f9"
  }
};

const pxToRem = (value) => `${value / 16}rem`;

const container = {
  fixedWidth: pxToRem(1164)
};

const size = {
  tablet: "768px",
  laptop: "1024px"
};
const device = {
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`
};

const fontSizes = {
  base: pxToRem(16),
  desc: pxToRem(14),
  xs: pxToRem(12),
  sm: pxToRem(18),
  md: pxToRem(20),
  lg: pxToRem(22),
  xl: pxToRem(26),
  xxl: pxToRem(28),
  xxxl: pxToRem(32),
  xxxxl: pxToRem(36)
};
const fontWeight = {
  book: 300,
  medium: 500,
  bold: 700
};
const fontType = {
  body: tokens.font.family
};

const screenReaderOnlyStyle = css`
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */
  height: 1px !important;
  overflow: hidden !important;
  margin: -1px !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
`;
const GlobalStyleArp = createGlobalStyle`
  html,
  body {
    box-sizing: border-box;
    height: 100%;
  }

  body {
    margin: 0;
  }

  body > div {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .sr-only {
    ${screenReaderOnlyStyle}
  }

  b,
  strong {
    font-weight: bold;
  }

  h1:focus-visible,
  h1:focus {
    outline: none;
  }
`;

const { breakpoints } = tokens;
const customMediaQuery = (width) => `@media screen and (min-width: ${pxToRem(width)})`;
const customMediaQueryDown = (width) => `@media screen and (max-width: ${pxToRem(width)})`;
const media = {
  tablet: customMediaQuery(breakpoints.md),
  tabletAndDown: customMediaQueryDown(breakpoints.md),
  desktop: customMediaQuery(breakpoints.lg),
  custom: customMediaQuery,
  print: "@media print"
};

const { getSpacing } = utils;
const { spacing: spacingType } = tokens;
const customSpacing = (width) => getSpacing(width);
const spacing$1 = {
  xs: getSpacing(spacingType.xs),
  sm: getSpacing(spacingType.sm),
  md: getSpacing(spacingType.md),
  lg: getSpacing(spacingType.lg),
  xl: getSpacing(spacingType.xl),
  xxl: getSpacing(spacingType.xxl),
  xxxl: getSpacing(spacingType.xxxl),
  custom: customSpacing,
  none: 0
};

const { getBreakpoint } = utils;
const ShowOnMobile = styled.div`
  display: block !important;
  ${getBreakpoint.md`
    display: none !important;
  `}
`;
const HideOnMobile = styled.div`
  display: none !important;
  ${getBreakpoint.md`
    display: block !important;
  `}
`;
const WeightBold = styled.span`
  font-weight: ${fontWeight.bold};
`;
const WeightMedium = styled.span`
  font-weight: ${fontWeight.medium};
`;
const WeightBook = styled.span`
  font-weight: ${fontWeight.book};
`;

const StyledContentContainer$1 = styled(ContentContainer)`
  padding: ${tokens.spacing.xs}px 0;

  ${utils.getBreakpoint.md`
  padding: ${tokens.spacing.sm}px 0;
`}

  ${utils.getBreakpoint.lg`
padding: ${tokens.spacing.sm}px 0;
`}
`;
const StyledHeaderContainer = styled(ContentContainer)`
  padding: ${tokens.spacing.sm}px 0;

  ${utils.getBreakpoint.md`
  padding: ${tokens.spacing.md}px 0;
`}

  ${utils.getBreakpoint.lg`
padding: ${tokens.spacing.lg}px 0;
`}
`;
const StyledTableContainer = styled(TableContainer)`
  overflow: hidden;

  > div {
    overflow-x: hidden;
  }
  table {
    table-layout: fixed;
    width: auto;
  }
  > p {
    text-align: right;
  }

  td,
  th {
    white-space: nowrap;
  }
`;
const StickyTable = styled(Table)`
  td:nth-child(1),
  td:nth-child(2) {
    background-color: white;
  }

  th:nth-child(1),
  th:nth-child(2) {
    background-color: ${`${tokens.colors.grey.geyser}`};
  }
  ${({ stickyColumns, offset }) => stickyColumns && stickyColumns === 1 ? css`
          td:nth-child(1),
          th:nth-child(1) {
            position: sticky;
            left: 0;
            z-index: 1;
            border-right: 2px solid ${`${tokens.colors.grey.geyser}`};
          }
        ` : css`
          td:nth-child(1),
          th:nth-child(1) {
            position: sticky;
            left: 0;
            z-index: 1;
          }

          td:nth-child(2),
          th:nth-child(2) {
            position: sticky;
            z-index: 1;
            left: ${offset || 0}px;
            border-right: 2px solid ${`${tokens.colors.grey.geyser}`};
          }
        `}
`;
const StyledTableHeader = styled(TableHeader)`
  padding: ${spacing$1.sm};
`;
const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  width: ${({ width }) => width ? `${pxToRem(width)}` : "200px"};
`;

const navigationItems = [
  {
    text: "Dashboard",
    url: "/dashboard",
    isDefault: true,
    applicable: ["auditor"]
  },
  {
    text: "Matters",
    url: "/matters",
    applicable: ["auditor"]
  },
  {
    text: "Notifications",
    url: "/notifications",
    applicable: ["auditor"]
  },
  {
    text: "My Profile",
    url: "/my-profile",
    applicable: ["auditor", "customer"],
    isLastItem: true
  }
];

const StyledNavigationContainer = styled(ContentContainer)`
  padding: ${tokens.spacing.xs}px ${tokens.spacing.xs}px 0;
  border-bottom: 1px solid ${tokens.colors.grey.geyser};
  display: none;
  ${utils.getBreakpoint.lg`
  display: block;
`}
`;
const StyledNavigation = styled.div`
  display: flex;
  flex-basis: 300px;
  flex-flow: row nowrap;
  align-items: center;
  > a {
    text-decoration: none;
  }
`;
const NavigationLink = styled(Link)`
  margin: ${tokens.spacing.xs}px ${tokens.spacing.md}px ${tokens.spacing.xs}px 0;
  padding-bottom: ${tokens.spacing.xs}px;
  margin-bottom: 0px;

  ${({ $active, $subMenu }) => $active && `
    border-bottom: 3px solid ${$subMenu ? tokens.colors.brand.snswPrimaryBlue : tokens.colors.brand.snswPrimaryRed};
    font-weight: bold;
  `}

  ${({ $lastItem }) => $lastItem && `margin-left: auto;`}
`;

const Navigation = ({
  items = navigationItems,
  isCustomer = false
}) => {
  const { pathname } = useLocation();
  const applicableFlag = isCustomer ? "customer" : "auditor";
  const filteredItems = items.filter(
    ({ applicable }) => applicable?.includes(applicableFlag)
  );
  const navItems = filteredItems.length === 0 ? items : filteredItems;
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledNavigationContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledNavigation, { children: navItems.map(
    ({ text, url, isLastItem = false, isSubMenu = false }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
      NavigationLink,
      {
        to: url,
        $active: pathname.includes(url),
        $lastItem: isLastItem,
        $subMenu: isSubMenu,
        children: text
      },
      url,
      false,
      {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/navigation/index.tsx",
        lineNumber: 35,
        columnNumber: 13
      },
      globalThis
    )
  ) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/navigation/index.tsx",
    lineNumber: 32,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/navigation/index.tsx",
    lineNumber: 31,
    columnNumber: 5
  }, globalThis);
};

const StyledFooter = styled.footer`
  background-color: ${tokens.colors.grey.darkGrey};
  color: #fff;
  font-size: ${utils.pxToRem(12)};
  font-weight: 400;
  line-height: 1.5;
`;
const FooterText = styled.p`
  border-bottom: 1px solid #fff;
  padding: 0 0 ${tokens.spacing.sm}px 0;
  margin: 0 0 ${tokens.spacing.sm}px 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const FooterLinks = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 0 0 ${tokens.spacing.md}px 0;

  > a {
    padding: ${tokens.spacing.xs}px 0;
    color: #fff;
    display: block;
    text-decoration: underline;
    margin-bottom: ${tokens.spacing.xs}px;

    ${utils.getBreakpoint.md`
    padding: 0 ${tokens.spacing.md}px 0 0;
  `}

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      border: ${utils.getSpacing(2)} solid #fff;
    }
  }

  ${utils.getBreakpoint.md`
  flex-flow: row nowrap;
  margin: 0 0 ${tokens.spacing.lg}px 0;
`}
`;

const footerLinks = [
  {
    text: "Accessibility",
    href: "https://www.revenue.nsw.gov.au/accessibility",
    isExternal: false
  },
  {
    text: "Privacy",
    href: "https://www.revenue.nsw.gov.au/privacy",
    isExternal: false
  },
  {
    text: "Terms",
    href: "https://www.revenue.nsw.gov.au/terms",
    isExternal: false
  }
];
const Footer = () => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledFooter, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ContentContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: [
  /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FooterText, { children: "We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued connection to their country and culture." }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
    lineNumber: 27,
    columnNumber: 9
  }, globalThis),
  /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FooterLinks, { children: footerLinks.map(({ href, text }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("a", { href, rel: "noreferrer", target: "_blank", children: text }, text, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
    lineNumber: 34,
    columnNumber: 13
  }, globalThis)) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
    lineNumber: 32,
    columnNumber: 9
  }, globalThis),
  /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("div", { children: "Copyright © 2023" }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
    lineNumber: 39,
    columnNumber: 9
  }, globalThis)
] }, void 0, true, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
  lineNumber: 26,
  columnNumber: 7
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
  lineNumber: 25,
  columnNumber: 5
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/footer/index.tsx",
  lineNumber: 24,
  columnNumber: 3
}, globalThis);

const StyledHeader = styled.header`
  border-bottom: 1px solid ${tokens.colors.grey.geyser};
  padding: 0;
`;
const HeaderText = styled.div`
  background-color: ${tokens.colors.brand.snswPrimaryBlue};
  color: #fff;
  font-size: ${utils.pxToRem(12)};
`;
const LogoContainer = styled.div`
  min-height: ${utils.pxToRem(64)};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${utils.getBreakpoint.md`
  justify-content: flex-start;
`}
`;
const Logo$2 = styled.img`
  height: ${utils.pxToRem(48)};
  ${utils.getBreakpoint.md`
  height: ${utils.pxToRem(76)};
`}
`;
const HeaderTextRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

const MastHead = ({
  headerAuthButton
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(HeaderText, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledContentContainer$1, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(HeaderTextRow, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("div", { children: "A NSW Government website" }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHead.tsx",
      lineNumber: 18,
      columnNumber: 13
    }, globalThis),
    headerAuthButton
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHead.tsx",
    lineNumber: 17,
    columnNumber: 11
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHead.tsx",
    lineNumber: 16,
    columnNumber: 9
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHead.tsx",
    lineNumber: 15,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHead.tsx",
    lineNumber: 14,
    columnNumber: 5
  }, globalThis);
};

const logo = "data:image/svg+xml;base64,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";

const HomeIconUrl = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9IiMyNDI5MzQiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTEwIDIwdi02aDR2Nmg1di04aDNMMTIgMyAyIDEyaDN2OHoiIGZpbGw9IiMyNDI5MzQiLz4KPC9zdmc+Cg==";

const MobileNavContainer = styled.nav`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  left: 0;
  height: 100vh;
  position: fixed;
  top: 0;
  touch-action: none;
  transition: transform 300ms ease-in-out;
  transform: ${({ $open }) => $open ? "translateX(0)" : "translateX(-100%)"};
  width: 100%;
  z-index: 10;

  > a {
    text-decoration: none;
  }
`;
const MobileNavContent = styled.div`
  padding: ${tokens.spacing.md}px;
  border: 1px solid ${tokens.colors.grey.geyser};
`;
const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${utils.pxToRem(20)};
  justify-content: space-around;
  outline: none;
  padding: 0;
  z-index: 2;
  width: ${utils.pxToRem(40)};
`;
const StyledMobileNavFooter = styled.div`
  background: ${tokens.colors.brand.snswPrimaryBlue};
  bottom: 0;
  color: #fff;
  height: ${utils.pxToRem(112)};
  padding: ${tokens.spacing.md}px;
  position: absolute;
  width: 100%;
  flex: 1;
`;
const MobileNavItem = styled(Link)`
  display: flex;
  flex-direction: row;
  border-left: ${({ $active }) => $active ? `${utils.pxToRem(3)} solid ${tokens.colors.brand.snswPrimaryRed}` : void 0};
  box-shadow: inset 0 -1px 0 ${tokens.colors.grey.iceBlue};
  color: ${({ $default }) => $default ? `${tokens.colors.grey.darkGrey}` : `${tokens.colors.brand.snswPrimaryBlue}`};
  font-size: ${utils.pxToRem(16)};
  line-height: ${utils.pxToRem(24)};
  padding: ${tokens.spacing.sm}px ${tokens.spacing.md}px;
  padding-left: ${({ $active }) => $active ? `${utils.getSpacing(21)}px` : `${tokens.spacing.md}px`};
`;
const HomeIcon = styled.div`
  background-image: url(${HomeIconUrl});
  background-repeat: no-repeat;
  padding-right: ${tokens.spacing.md}px;
  width: ${utils.pxToRem(20)};
  height: ${utils.pxToRem(20)};
`;

const MobileNavigation = ({
  isOpen,
  setIsOpen
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MobileNavContainer, { $open: isOpen, children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MobileNavContent, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(CloseButton, { onClick: () => setIsOpen(!isOpen), "aria-label": "close", children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(IconClose, { color: "primaryBlue" }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
      lineNumber: 25,
      columnNumber: 11
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
      lineNumber: 24,
      columnNumber: 9
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
      lineNumber: 23,
      columnNumber: 7
    }, globalThis),
    navigationItems?.map(({ text, url, isDefault }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
      MobileNavItem,
      {
        to: url,
        $active: url === window.location.pathname,
        $default: isDefault,
        children: [
          isDefault && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(HomeIcon, {}, void 0, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
            lineNumber: 36,
            columnNumber: 25
          }, globalThis),
          /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("span", { children: text }, void 0, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
            lineNumber: 37,
            columnNumber: 11
          }, globalThis)
        ]
      },
      url,
      true,
      {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
        lineNumber: 30,
        columnNumber: 9
      },
      globalThis
    )),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledMobileNavFooter, {}, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
      lineNumber: 41,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/mobileNavigation/index.tsx",
    lineNumber: 22,
    columnNumber: 5
  }, globalThis);
};

const MenuContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: ${utils.pxToRem(40)};

  ${utils.getBreakpoint.md`
 display: none;
  `}
`;
const StyledMenu = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: ${utils.pxToRem(20)};
  justify-content: space-around;
  outline: none;
  padding: 0;
  z-index: 2;
`;
const MenuText = styled.div`
  color: ${tokens.colors.brand.snswPrimaryBlue};
  cursor: pointer;
  font-size: ${utils.pxToRem(14)};
  font-weight: 600;
`;

const Menu = ({
  isOpen,
  setIsOpen
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MenuContainer, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MobileNavigation, { isOpen, setIsOpen }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/menu/index.tsx",
      lineNumber: 16,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledMenu, { onClick: () => setIsOpen(!isOpen), "aria-label": "menu", children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(IconMenu, { color: "primaryBlue" }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/menu/index.tsx",
      lineNumber: 18,
      columnNumber: 9
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/menu/index.tsx",
      lineNumber: 17,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MenuText, { onClick: () => setIsOpen(!isOpen), children: "Menu" }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/menu/index.tsx",
      lineNumber: 20,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/menu/index.tsx",
    lineNumber: 15,
    columnNumber: 5
  }, globalThis);
};

const MastHeadBrand = () => {
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledContentContainer$1, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(LogoContainer, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Menu, { isOpen, setIsOpen }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHeadBrand.tsx",
      lineNumber: 16,
      columnNumber: 11
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Logo$2, { src: logo, alt: "NSW Government" }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHeadBrand.tsx",
      lineNumber: 17,
      columnNumber: 11
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHeadBrand.tsx",
    lineNumber: 15,
    columnNumber: 9
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHeadBrand.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/mastHeadBrand.tsx",
    lineNumber: 13,
    columnNumber: 5
  }, globalThis);
};

const Header = ({
  headerAuthButton
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledHeader, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MastHead, { headerAuthButton }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/index.tsx",
      lineNumber: 14,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(MastHeadBrand, {}, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/index.tsx",
      lineNumber: 15,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/header/index.tsx",
    lineNumber: 13,
    columnNumber: 5
  }, globalThis);
};

const PageContent = styled.div`
  flex: 1;
`;
const StyledHeadingText = styled.div`
  border-top: 1px solid ${tokens.colors.grey.geyser};
  border-bottom: 1px solid ${tokens.colors.grey.geyser};
  color: ${tokens.colors.brand.snswPrimaryBlue};
  display: none;
  ${utils.getBreakpoint.xl`
  display: block;
`}
`;
const StyledAMSContentContainer = styled(ContentContainer)`
  min-height: 600px;
`;

const RootLayout = ({
  headingText = "Compliance portal",
  showNavigation = true,
  children,
  headerAuthButton,
  isCustomer
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(jsxDevRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(PageContent, { children: [
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Header, { headerAuthButton }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 30,
        columnNumber: 9
      }, globalThis),
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledHeadingText, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledHeaderContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Heading, { level: 1, children: headingText }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 34,
        columnNumber: 15
      }, globalThis) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 33,
        columnNumber: 13
      }, globalThis) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 32,
        columnNumber: 11
      }, globalThis) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 31,
        columnNumber: 9
      }, globalThis),
      showNavigation && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Navigation, { isCustomer }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
        lineNumber: 39,
        columnNumber: 28
      }, globalThis),
      children
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
      lineNumber: 29,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Footer, {}, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
      lineNumber: 43,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/rootLayout/index.tsx",
    lineNumber: 28,
    columnNumber: 5
  }, globalThis);
};

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing$1.xs};

  ${({ hasMarginTop }) => hasMarginTop && `
  margin-top: ${spacing$1.sm};
  `}
  ${({ hasMarginBottom }) => hasMarginBottom && `
margin-bottom: ${spacing$1.sm};
`}
`;
const FlexItem = styled.div`
  display: flex;
  align-items: baseline;
`;
const HeadingItem = styled.div`
  font-size: 1rem;
  font-weight: 700;
  flex: 1;
`;
const DescriptionItem = styled.div`
  flex: 3;
`;

const LabelDescriptionList = ({
  list,
  hasMarginTop,
  hasMarginBottom
}) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FlexContainer, { hasMarginTop, hasMarginBottom, children: list?.map(({ label, description }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FlexItem, { children: [
  /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(HeadingItem, { children: label }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/labelDescriptionList/index.tsx",
    lineNumber: 19,
    columnNumber: 9
  }, globalThis),
  /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(DescriptionItem, { children: description }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/labelDescriptionList/index.tsx",
    lineNumber: 20,
    columnNumber: 9
  }, globalThis)
] }, `${label}`, true, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/labelDescriptionList/index.tsx",
  lineNumber: 18,
  columnNumber: 7
}, globalThis)) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/labelDescriptionList/index.tsx",
  lineNumber: 16,
  columnNumber: 3
}, globalThis);

const StyledProgressHeader = styled.div`
  background-color: ${tokens.colors.grey.iceBlue};

  padding: ${tokens.spacing.sm}px 0;

  ${utils.getBreakpoint.md`
  padding: ${tokens.spacing.sm}px 0;
`}

  ${utils.getBreakpoint.lg`
padding:  0;
`}
`;

const ProgressHeader = ({
  title = "",
  label = "",
  stepsList = []
}) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledProgressHeader, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SectionPage, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FormHeader, { title, label, stepsList }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressHeader/index.tsx",
  lineNumber: 13,
  columnNumber: 7
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressHeader/index.tsx",
  lineNumber: 12,
  columnNumber: 5
}, globalThis) }, void 0, false, {
  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressHeader/index.tsx",
  lineNumber: 11,
  columnNumber: 3
}, globalThis);

var StepStatus$1 = /* @__PURE__ */ ((StepStatus2) => {
  StepStatus2["Current"] = "current";
  StepStatus2["ToDo"] = "todo";
  StepStatus2["Completed"] = "completed";
  return StepStatus2;
})(StepStatus$1 || {});

const StyledShowMore = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colours.text.link};
  margin-bottom: ${spacing$1.xs};
  order: 1;

  > span {
    margin-right: ${spacing$1.xs};
    border-bottom: 1px solid ${colours.text.link};

    &:hover,
    &:active {
      border-bottom: 1px solid ${colours.text.link};
    }
  }
  > svg {
    fill: ${colours.text.link};
  }
`;

const ShowMore = ({ children }) => {
  const [isShowing, setIsShowing] = useState(false);
  const onClick = () => setIsShowing(!isShowing);
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(jsxDevRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
      StyledShowMore,
      {
        role: "button",
        tabIndex: 0,
        onKeyDown: onClick,
        onClick,
        children: [
          /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("span", { children: isShowing ? "Show less" : "Show more" }, void 0, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/showMore/index.tsx",
            lineNumber: 19,
            columnNumber: 9
          }, globalThis),
          isShowing ? /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(IconChevronUp, { color: "primaryBlue" }, void 0, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/showMore/index.tsx",
            lineNumber: 21,
            columnNumber: 11
          }, globalThis) : /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(IconChevronDown, { color: "primaryBlue" }, void 0, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/showMore/index.tsx",
            lineNumber: 23,
            columnNumber: 11
          }, globalThis)
        ]
      },
      void 0,
      true,
      {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/showMore/index.tsx",
        lineNumber: 13,
        columnNumber: 7
      },
      globalThis
    ),
    isShowing && children
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/showMore/index.tsx",
    lineNumber: 12,
    columnNumber: 5
  }, globalThis);
};

const BreadCrumbLink = styled(Link)`
  font-size: ${fontSizes.xs};
  line-height: ${pxToRem(20)};
  text-decoration-line: underline;
  color: ${colours.neutral.darker};
  margin-right: ${spacing$1.xs};
`;
const BreadCrumbNoLink = styled.span`
  font-size: ${fontSizes.xs};
  line-height: ${pxToRem(20)};
  text-decoration-line: none;
  color: ${colours.neutral.darker};
  margin-right: ${spacing$1.xs};
`;
const ChevronIcon = css`
  background-image: url('data:image/svg+xml, <svg viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33516 0L0.160156 1.175L3.97682 5L0.160156 8.825L1.33516 10L6.33516 5L1.33516 0Z" fill="%23242934"/></svg>');
`;
const StyledList = styled.ol`
  display: flex;
  list-style: none;
  position: relative;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  gap: ${spacing$1.sm};

  ${media.print} {
    display: none;
  }

  li {
    ${(props) => `&:not(:nth-child( -n + ${props.leafIndex} )) {
      display: none;
    }`}
    ${(props) => `&:nth-child(-n + ${props.leafIndex}) {
      &::after {
        content: '';
        position: absolute;
        width: ${pxToRem(7)};
        height: ${pxToRem(15)};
        ${ChevronIcon};
        margin-top: ${spacing$1.xs};
        background-repeat: no-repeat;
      }
    }`}

    margin-bottom: ${spacing$1.xs};

    ${media.tablet} {
      ${(props) => `&:not(:nth-child(${props.leafIndex})) {
          display: block;
      }`}

      padding: 0;

      :first-child {
        padding-left: 0;
      }

      :not(:first-child) {
        padding-left: ${spacing$1.sm};
      }

      :not(:last-child)::after {
        content: '';
        position: absolute;
        width: ${pxToRem(7)};
        height: ${pxToRem(15)};

        ${ChevronIcon};

        margin-top: ${spacing$1.xs};
        background-repeat: no-repeat;
      }
    }
  }
`;

const Breadcrumbs = ({
  paths,
  leafPathIndex,
  isAccessible = true
}) => {
  if (!isAccessible) {
    return null;
  }
  const leafIndex = leafPathIndex || paths.length - 1;
  const renderLink = (currentIndex, path) => {
    if (currentIndex < leafIndex) {
      return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(BreadCrumbLink, { to: path.path || "", children: path.display }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/breadcrumbs/index.tsx",
        lineNumber: 16,
        columnNumber: 9
      }, globalThis);
    }
    return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(BreadCrumbNoLink, { children: path.display }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/breadcrumbs/index.tsx",
      lineNumber: 19,
      columnNumber: 12
    }, globalThis);
  };
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("nav", { "aria-label": "breadcrumbs", role: "navigation", children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledList, { leafIndex, children: paths.map((path, index) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { children: renderLink(index, path) }, path.path || index, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/breadcrumbs/index.tsx",
    lineNumber: 25,
    columnNumber: 11
  }, globalThis)) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/breadcrumbs/index.tsx",
    lineNumber: 23,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/breadcrumbs/index.tsx",
    lineNumber: 22,
    columnNumber: 5
  }, globalThis);
};

const { layouts } = tokens;
const FieldError = css`
  border-color: ${tokens.colors.borders.error};
  color: ${tokens.colors.forms.inputText};
  box-shadow: none;
`;
const StyledWrapper = styled.div`
  position: relative;
  max-width: ${(props) => props.inputWidth ? pxToRem(layouts.inputWidth[props.inputWidth]) : "100%"};

  > input {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23242934' d='M16 5a1 1 0 00-1.71-.71L8 10.59l-6.29-6.3A1.004 1.004 0 00.29 5.71l7 7a1 1 0 001.42 0l7-7A1 1 0 0016 5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right ${pxToRem(18)} center;
    cursor: pointer;
    &:-moz-focusring {
      color: transparent;
      text-shadow: 0 0 0 #000;
    }
    &::-ms-expand {
      display: none;
    }
    padding-right: ${pxToRem(60)};
    ${(props) => props.hasError && css`
        ${FieldError}
      `}
  }
`;
const StyledOptionsWrapper = styled.ul`
  position: absolute;
  width: 100%;

  list-style: none;
  padding: 0 ${pxToRem(10)};
  padding-bottom: ${pxToRem(20)};
  margin-block-start: ${pxToRem(2)};
  border: solid ${pxToRem(2)} #646974;
  border-top: none;
  border-radius: 0 0 ${pxToRem(6)} ${pxToRem(6)};
  background-color: white;
  z-index: 99;

  > li#empty {
    margin-top: ${pxToRem(10)};
  }
`;

const VALUE_SELECT_ALL = "_ALL_";
const MultiSelect = ({
  name,
  value,
  inputWidth,
  showSelectAll = false,
  selectAllLabel,
  onChange,
  onBlur,
  options,
  hasError,
  singleSelectionLabel,
  multipleSelectionLabel
}) => {
  const dropdownRef = useRef(null);
  const [selectAll, setSelectAll] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const toggleShowOptions = () => setShowOptions(!showOptions);
  const selectedValue = value.split(",");
  const combinedOptions = showSelectAll ? [
    {
      text: selectAllLabel || "Select all",
      value: VALUE_SELECT_ALL
    },
    ...options
  ] : options;
  const itemsSelected = options.filter(
    ({ value: v }) => selectedValue.includes(v)
  ).length;
  const selectedOption = options.find(
    (option) => selectedValue.length === 1 && option.value === value
  );
  const displayText = (
    // eslint-disable-next-line no-nested-ternary
    selectAll && options.length > 0 ? `All ${multipleSelectionLabel ?? `${name}s`}` : (
      // eslint-disable-next-line no-nested-ternary
      itemsSelected > 0 ? itemsSelected === 1 ? `${selectedOption?.labelText ? `${selectedOption?.labelText}` : `${itemsSelected} ${singleSelectionLabel ?? name} selected`}` : `${itemsSelected} ${multipleSelectionLabel ?? `${name}s`} selected` : ""
    )
  );
  useEffect(() => {
    if (itemsSelected === options.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [itemsSelected, options]);
  const handleSelectionChange = (optionValue) => (checkValue) => {
    let newValue = selectedValue;
    if (optionValue === VALUE_SELECT_ALL) {
      if (checkValue) {
        newValue = options.map(({ value: v }) => v);
      } else {
        newValue = [];
      }
      setSelectAll(!!checkValue);
    } else {
      newValue = checkValue === "" ? selectedValue.filter((v) => v !== optionValue) : [...selectedValue, checkValue];
      if (!checkValue && selectAll) {
        setSelectAll(false);
      } else if (checkValue && !selectAll) {
        const allSelected = options.every(
          ({ value: v }) => newValue.includes(v)
        );
        setSelectAll(allSelected);
      }
    }
    onChange(newValue.filter((val) => val !== "").join(","));
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    window.addEventListener("mousedown", handleOutsideClick);
    return () => {
      window.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    StyledWrapper,
    {
      inputWidth,
      hasError: !!hasError,
      ref: dropdownRef,
      children: [
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
          Input,
          {
            name,
            onClick: toggleShowOptions,
            value: displayText,
            onBlur
          },
          void 0,
          false,
          {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
            lineNumber: 128,
            columnNumber: 7
          },
          globalThis
        ),
        showOptions && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledOptionsWrapper, { children: options.length === 0 ? /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { id: "empty", children: [
          "No ",
          name,
          "s available"
        ] }, void 0, true, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
          lineNumber: 137,
          columnNumber: 13
        }, globalThis) : combinedOptions.map(({ text, value: optionValue }) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
          FormCheckbox,
          {
            name: `${name}_checkboxes_${optionValue}`,
            checked: optionValue === VALUE_SELECT_ALL ? selectAll : selectedValue.includes(optionValue),
            label: text,
            value: optionValue,
            onChange: handleSelectionChange(optionValue)
          },
          void 0,
          false,
          {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
            lineNumber: 141,
            columnNumber: 17
          },
          globalThis
        ) }, `li_${optionValue}`, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
          lineNumber: 140,
          columnNumber: 15
        }, globalThis)) }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
          lineNumber: 135,
          columnNumber: 9
        }, globalThis)
      ]
    },
    void 0,
    true,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/multiSelect/multiSelect.tsx",
      lineNumber: 123,
      columnNumber: 5
    },
    globalThis
  );
};

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 325);
  }, [pathname]);
  return children;
};

const StyledContentContainer = styled(ContentContainer)`
  > button,
  a {
    margin-top: ${spacing$1.md};
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error({
      message: error,
      source: typeof ErrorBoundary,
      additionalInfo: [errorInfo]
    });
  }
  render() {
    const { hasError } = this.state;
    if (hasError) {
      return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledContentContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
        ErrorSystemPage,
        {
          detail: "Unfortunately it looks like there was an issue while processing your request",
          heading: "Sorry, we were unable to process your request",
          tryAgainOnClick: () => {
            window.location.reload();
          }
        },
        void 0,
        false,
        {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorBoundary/index.tsx",
          lineNumber: 35,
          columnNumber: 11
        },
        this
      ) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorBoundary/index.tsx",
        lineNumber: 34,
        columnNumber: 9
      }, this);
    }
    const { children } = this.props;
    return children;
  }
}

const isNullOrEmpty = (value) => !value || value === "";
const formatDate = (dateStr, dateOutputFormatter = "DD MMM YYYY", isoFormat = false) => {
  if (!dateStr) {
    return "";
  }
  try {
    const parsedDate = dayjs(dateStr);
    if (isoFormat) {
      return parsedDate.toISOString();
    }
    return parsedDate.format(dateOutputFormatter);
  } catch (error) {
    console.error("Error occurred while formatting date:", error);
    return "";
  }
};

const StyledInPageAlert = styled(InPageAlert)`
  ${(props) => props.isRead === "true" && `
      background: ${colours.backgrounds.default};
      border-top: ${spacing$1.custom(2)} solid ${colours.borders.dark};
      border-left: none;
      &: last-child {
        border-bottom: ${spacing$1.custom(2)} solid ${colours.borders.dark};
      }
      &: not(: first-child) {
        margin: ${spacing$1.none} ;
      }
    `}
  span {
    float: right;
    margin-top: -3.8%;
  }
`;

const InPageAlertWithTimestamp = ({
  title,
  timestamp,
  isRead,
  children
}) => {
  const date = formatDate(timestamp, "DD MMM YYYY HH:mm");
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    StyledInPageAlert,
    {
      variant: "info",
      title,
      headingElement: "h4",
      isRead,
      children: [
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("span", { children: `${date}` }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/inPageAlertWithTimestamp/index.tsx",
          lineNumber: 29,
          columnNumber: 7
        }, globalThis),
        children
      ]
    },
    void 0,
    true,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/inPageAlertWithTimestamp/index.tsx",
      lineNumber: 23,
      columnNumber: 5
    },
    globalThis
  );
};

const MatterAlert = (props) => {
  const {
    title,
    timestamp,
    body,
    isRead = false,
    linkUrl,
    linkText,
    onClick
  } = props;
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    InPageAlertWithTimestamp,
    {
      title,
      timestamp,
      isRead: isRead?.toString(),
      children: [
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: body }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/matterAlert/index.tsx",
          lineNumber: 23,
          columnNumber: 7
        }, globalThis),
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Link, { to: linkUrl || "", onClick, children: linkText }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/matterAlert/index.tsx",
          lineNumber: 25,
          columnNumber: 9
        }, globalThis) }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/matterAlert/index.tsx",
          lineNumber: 24,
          columnNumber: 7
        }, globalThis)
      ]
    },
    void 0,
    true,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/matterAlert/index.tsx",
      lineNumber: 18,
      columnNumber: 5
    },
    globalThis
  );
};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
const PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

const content$2 = {
  "errorSummary.heading": "Your form has errors",
  "errorSummary.description": "Check the following Errors"
};

const content$1 = {
  "fileUpload.heading": "Upload documents",
  "fileUpload.dropzone.text": "Drag and drop files into this box or use the button to select and upload your files.",
  "fileUpload.dropzone.fileSize.text": "Each file size must not exceed 50 MB.",
  "fileUpload.dropzone.button.text": "Select documents"
};

const content = {
  "matterAlert.alert.heading": "New matter received",
  "matterAlert.alert.message": "You have received a new matter {matterId} for {clientName}"
};

const combinedComponentContents = {
  // Features
  ...content,
  ...content$1,
  ...content$2
};

const combineContent = {
  ...combinedComponentContents
};
const getContent = (key) => {
  const { [key]: value } = combineContent;
  return value;
};

const MAX_SIZE = 50 * 1024 * 1024;

const Container$2 = styled.div`
  div {
    text-align: center;
  }
`;
const StyledHeading = styled(Heading)`
  margin-top: 0;
`;
const DropzoneContainer = styled.div`
  height: 100%;
`;
const DropzoneFileUploadContainer = styled.div`
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
  background-color: #fff;
  height: ${pxToRem(244)};

  p {
    margin: 0;
  }

  span {
    display: flex;
  }

  fieldset {
    height: 100%;
  }
`;
const UploadIcon = styled(IconUpload)`
  width: ${pxToRem(tokens.spacing.lg)};
  height: ${pxToRem(tokens.spacing.lg)};
  fill: ${colours.neutral.dark};
  margin-top: ${spacing$1.xs};
  margin-bottom: ${spacing$1.md};
`;
const FileUploadButton = styled(Button)`
  margin-top: -${pxToRem(72)};
  margin-left: -${pxToRem(88)};
  position: absolute;
  z-index: 1;
`;

const ErrorMessage = ({ invalidFileNames }) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    InPageAlert,
    {
      title: "The following file(s) exceeding the 50MB limit. Please try again by excluding the associated file(s) or by reducing the size.",
      variant: "error",
      children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("ul", { children: invalidFileNames.map((fileName) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { children: fileName }, fileName, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
        lineNumber: 31,
        columnNumber: 11
      }, globalThis)) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
        lineNumber: 29,
        columnNumber: 7
      }, globalThis)
    },
    void 0,
    false,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
      lineNumber: 25,
      columnNumber: 5
    },
    globalThis
  );
};
const FileUpload = ({ onFileUpload, showHeading = false }) => {
  const [invalidFileNames, setInvalidFileNames] = useState([]);
  const fileInputRef = useRef(null);
  const handleFileValidation = useCallback(
    (files) => {
      const invalidFileNames2 = [];
      files.forEach((file) => {
        if (file.size > MAX_SIZE) {
          invalidFileNames2.push(file.name);
        }
      });
      if (invalidFileNames2.length === 0) {
        onFileUpload(files);
      }
      setInvalidFileNames(invalidFileNames2);
    },
    [onFileUpload]
  );
  const handleFileDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      const allFiles = [
        ...acceptedFiles,
        ...fileRejections.map((fileRejection) => fileRejection.file)
      ];
      handleFileValidation(allFiles);
    },
    [handleFileValidation]
  );
  const handleManualUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleFileDrop,
    // accept: ACCEPTED_FORMATS, - Commented for now as we should allow all the formats
    maxSize: MAX_SIZE
    // 50 MB in bytes
  });
  const preventDefaultClick = (event) => {
    event.preventDefault();
  };
  const handleFileChange = (event) => {
    if (event.target.files) {
      const fileList = Array.from(event.target.files);
      handleFileValidation(fileList);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(jsxDevRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Container$2, { children: [
      showHeading && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledHeading, { level: 4, children: getContent("fileUpload.heading") }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
        lineNumber: 103,
        columnNumber: 11
      }, globalThis),
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(DropzoneFileUploadContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Fieldset, { hasError: Boolean(invalidFileNames.length > 0), children: [
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
          DropzoneContainer,
          {
            ...getRootProps({ className: "dropzone" }),
            onClick: preventDefaultClick,
            children: [
              /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(UploadIcon, {}, void 0, false, {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
                lineNumber: 113,
                columnNumber: 15
              }, globalThis),
              /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("input", { ...getInputProps() }, void 0, false, {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
                lineNumber: 114,
                columnNumber: 15
              }, globalThis),
              /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: getContent("fileUpload.dropzone.text") }, void 0, false, {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
                lineNumber: 115,
                columnNumber: 15
              }, globalThis),
              /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: getContent("fileUpload.dropzone.fileSize.text") }, void 0, false, {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
                lineNumber: 116,
                columnNumber: 15
              }, globalThis)
            ]
          },
          void 0,
          true,
          {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
            lineNumber: 109,
            columnNumber: 13
          },
          globalThis
        ),
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
          "input",
          {
            multiple: true,
            type: "file",
            style: { display: "none" },
            ref: fileInputRef,
            onChange: handleFileChange
          },
          Math.random(),
          false,
          {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
            lineNumber: 119,
            columnNumber: 13
          },
          globalThis
        ),
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(FileUploadButton, { variant: "secondary", onClick: handleManualUpload, children: getContent("fileUpload.dropzone.button.text") }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
          lineNumber: 127,
          columnNumber: 13
        }, globalThis)
      ] }, void 0, true, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
        lineNumber: 108,
        columnNumber: 11
      }, globalThis) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
        lineNumber: 107,
        columnNumber: 9
      }, globalThis)
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
      lineNumber: 101,
      columnNumber: 7
    }, globalThis),
    invalidFileNames.length > 0 && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ErrorMessage, { invalidFileNames }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
      lineNumber: 134,
      columnNumber: 9
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/fileUpload/index.tsx",
    lineNumber: 100,
    columnNumber: 5
  }, globalThis);
};

const ErrorSummary = ({ errors }) => {
  const scrollToField = (e, fieldName) => {
    e.preventDefault();
    const element = document.querySelector(`[name=${fieldName}]`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  if (errors && Object.keys(errors).length > 0) {
    return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("div", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(InPageAlert, { title: getContent("errorSummary.heading"), variant: "error", children: [
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: getContent("errorSummary.description") }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
        lineNumber: 27,
        columnNumber: 11
      }, globalThis),
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("ul", { children: Object.keys(errors).map((errorKey) => {
        const error = errors[errorKey];
        if (Array.isArray(error)) {
          return error.map((err) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
            "a",
            {
              href: `#${errorKey}`,
              onClick: (e) => scrollToField(e, errorKey),
              children: err
            },
            void 0,
            false,
            {
              fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
              lineNumber: 34,
              columnNumber: 21
            },
            globalThis
          ) }, `${errorKey}`, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
            lineNumber: 33,
            columnNumber: 19
          }, globalThis));
        }
        if (typeof error === "string") {
          return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("li", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
            "a",
            {
              href: `#${errorKey}`,
              onClick: (e) => scrollToField(e, errorKey),
              children: error
            },
            void 0,
            false,
            {
              fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
              lineNumber: 46,
              columnNumber: 21
            },
            globalThis
          ) }, errorKey, false, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
            lineNumber: 45,
            columnNumber: 19
          }, globalThis);
        }
        return null;
      }) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
        lineNumber: 28,
        columnNumber: 11
      }, globalThis)
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
      lineNumber: 26,
      columnNumber: 9
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/errorSummary/index.tsx",
      lineNumber: 25,
      columnNumber: 7
    }, globalThis);
  }
  return null;
};

const tooltipIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDE2QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEMxMi40MTgzIDAgMTYgMy41ODE3MiAxNiA4QzE2IDEwLjEyMTcgMTUuMTU3MSAxMi4xNTY2IDEzLjY1NjkgMTMuNjU2OUMxMi4xNTY2IDE1LjE1NzEgMTAuMTIxNyAxNiA4IDE2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDhDMiAxMS4zMTM3IDQuNjg2MjkgMTQgOCAxNEM5LjU5MTMgMTQgMTEuMTE3NCAxMy4zNjc5IDEyLjI0MjYgMTIuMjQyNkMxMy4zNjc5IDExLjExNzQgMTQgOS41OTEzIDE0IDhDMTQgNC42ODYyOSAxMS4zMTM3IDIgOCAyQzQuNjg2MjkgMiAyIDQuNjg2MjkgMiA4Wk0wIDhDMCAxMi40MTgzIDMuNTgxNzIgMTYgOCAxNkMxMC4xMjE3IDE2IDEyLjE1NjYgMTUuMTU3MSAxMy42NTY5IDEzLjY1NjlDMTUuMTU3MSAxMi4xNTY2IDE2IDEwLjEyMTcgMTYgOEMxNiAzLjU4MTcyIDEyLjQxODMgMCA4IDBDMy41ODE3MiAwIDAgMy41ODE3MiAwIDhaTTkgMTFWOEM5IDcuNDQ3NzIgOC41NTIyOSA3IDggN0M3LjQ0NzcyIDcgNyA3LjQ0NzcyIDcgOFYxMUM3IDExLjU1MjMgNy40NDc3MiAxMiA4IDEyQzguNTUyMjkgMTIgOSAxMS41NTIzIDkgMTFaTTguMTkgNkM4LjI1NjI0IDUuOTkwNzMgOC4zMjA0NSA1Ljk3MDQ1IDguMzggNS45NEM4LjQ0MTQzIDUuOTIwMDMgOC40OTg5NSA1Ljg4OTU4IDguNTUgNS44NUM4LjYwNzIxIDUuODE1NDUgOC42NjA4MSA1Ljc3NTI1IDguNzEgNS43M0M4Ljg5OTMxIDUuNTQyMjMgOS4wMDU4IDUuMjg2NjQgOS4wMDU4IDUuMDJDOS4wMDU4IDQuNzUzMzYgOC44OTkzMSA0LjQ5Nzc3IDguNzEgNC4zMUM4LjQyNjQ4IDQuMDI0MDcgNy45OTkxMiAzLjkzNjA3IDcuNjI1NzEgNC4wODY3NUM3LjI1MjI5IDQuMjM3NDMgNy4wMDU2OCA0LjU5NzM3IDcgNUM3IDUuNTUyMjkgNy40NDc3MiA2IDggNkg4LjE5WiIgZmlsbD0iIzI0MjkzNCIvPgo8L3N2Zz4K";

const Container$1 = styled.div`
  display: flex;
  align-items: center;
  font-size: ${pxToRem(16)};
`;
const Label = styled.label`
  margin-right: ${spacing$1.xs};
`;
const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-top: ${spacing$1.xs};
`;
const Icon = styled.span`
  cursor: pointer;
`;
const TooltipText = styled.span`
  display: ${(props) => props.show ? "block" : "none"};
  background-color: ${colours.neutral.dark};
  color: white;
  text-align: center;
  border-radius: ${spacing$1.xs};
  padding: ${spacing$1.xs};
  position: absolute;
  z-index: 1;
  left: 50%;
  transform: translateX(${(props) => props.noTranslateLeft ? "0" : "-50%"});
  width: ${pxToRem(400)};
  white-space: pre-line;
  margin-left: ${(props) => props.alignLeft ? `-${pxToRem(208)}` : "0"};
  bottom: ${(props) => props.alignLeft ? "50%" : "100%"};
`;
const TooltipIcon = styled.img`
  height: ${pxToRem(16)};
  ${({ $headerIcon }) => $headerIcon && `margin-top: ${spacing$1.xs};`}
`;

const Tooltip = ({
  label,
  text,
  alignLeft = false,
  noTranslateLeft
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Container$1, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Label, { children: label }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
      lineNumber: 18,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(TooltipContainer, { children: [
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
        Icon,
        {
          onMouseOver: () => setShowTooltip(true),
          onMouseLeave: () => setShowTooltip(false),
          children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
            TooltipIcon,
            {
              src: tooltipIcon,
              alt: "tooltip",
              $headerIcon: React.isValidElement(label)
            },
            void 0,
            false,
            {
              fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
              lineNumber: 24,
              columnNumber: 11
            },
            globalThis
          )
        },
        void 0,
        false,
        {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
          lineNumber: 20,
          columnNumber: 9
        },
        globalThis
      ),
      /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
        TooltipText,
        {
          show: showTooltip,
          alignLeft,
          noTranslateLeft,
          children: text
        },
        void 0,
        false,
        {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
          lineNumber: 30,
          columnNumber: 9
        },
        globalThis
      )
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
      lineNumber: 19,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/tooltip/index.tsx",
    lineNumber: 17,
    columnNumber: 5
  }, globalThis);
};

var StepStatus = /* @__PURE__ */ ((StepStatus2) => {
  StepStatus2["Current"] = "current";
  StepStatus2["ToDo"] = "todo";
  StepStatus2["Completed"] = "completed";
  return StepStatus2;
})(StepStatus || {});

const ProgressStepperList = styled.ol`
  display: flex;
  flex-flow: row nowrap;
  padding-inline-start: 0;
  align-content: flex-start;
  margin-block-end: 0;
  margin-block-start: 0;
`;
const ProgressStepperStep = styled.li`
  display: flex;
  flex-flow: column wrap;
  position: relative;
  width: auto;
  flex: 16%;
  text-align: center;
  padding: 0;
  margin-bottom: 0;

  ${utils.getBreakpoint.md`
        align-content: center;
        align-items: center;
        flex-flow: column nowrap;
    `}  

  &:after {
    content: '';
    width: 100%;
    height: 3px;
    position: absolute;
    right: 0;
    top: 14px;
    ${utils.getBreakpoint.md`
            right: -50%;
        `}
  }

  /* previous positions */
  ${(props) => (props.status === "completed" || props.status === "current") && css`
      font-weight: ${tokens.font.weight.book};
      color: ${tokens.colors.brand.snswPrimaryBlue};
      &:after {
        background-color: ${tokens.colors.brand.snswPrimaryBlue};
      }
      div {
        background-color: ${tokens.colors.brand.snswPrimaryBlue};
        border: 2px solid ${tokens.colors.brand.snswPrimaryBlue};
      }
    `}

  /* next positions */
    ${(props) => props.status === "todo" && css`
        font-weight: ${tokens.font.weight.book};
        color: ${colours.grey.shuttle};
        &:after {
          background-color: ${colours.grey.shuttle};
        }
        div {
          background-color: ${colours.neutral.xLight};
        }
      `}

    /* active position */
    ${(props) => props.status === "current" && css`
        background-color: transparent;
        font-weight: ${tokens.font.weight.bold};
        color: ${tokens.colors.brand.snswPrimaryBlue};

        div {
          font-size: ${utils.pxToRem(16)};
          background: ${tokens.colors.brand.snswPrimaryBlue};
          border: 2px solid ${tokens.colors.brand.snswPrimaryBlue};
          color: ${colours.neutral.xLight};
        }
        &:after {
          background-color: ${colours.grey.shuttle};
        }
      `}

    &:last-child {
    &:after {
      display: none;
    }
  }

  section {
    display: flex;
    align-items: center;
    gap: 8px;
    div {
      padding-top: 0;
      margin-top: 1.5rem;
      display: flex;
      align-items: center;
      width: 16px;
      height: 16px;
      background: ${tokens.colors.legacy.green};
      border: 2px solid ${tokens.colors.legacy.green};
      svg {
        background: none;
      }
  }
`;
const StepPosition = styled.div`
  font-size: ${utils.pxToRem(14)};
  border-radius: 50%;
  width: ${utils.getSpacing("lg")};
  height: ${utils.getSpacing("lg")};
  padding: 3px;
  text-align: center;
  background: ${colours.neutral.xLight};
  border: 2px solid ${colours.grey.shuttle};
  color: ${colours.grey.shuttle};
  z-index: 1;
  svg {
    background-color: ${tokens.colors.brand.snswPrimaryBlue};
    margin-top: ${utils.pxToRem(3)};
  }

  ${(props) => (props.status === "completed" || props.status === "current") && css`
      color: #fff;
    `}
`;
styled.span`
  font-size: ${tokens.font.size.base};
  font-weight: ${tokens.font.weight.bold};
  color: ${tokens.colors.brand.snswPrimaryBlue};
  margin-top: ${utils.getSpacing("sm")};
  display: block;

  ${utils.getBreakpoint.md`
        display: none;
    `}
`;
const StepLabel = styled.span`
  margin-top: ${utils.getSpacing("md")};
  display: none;

  ${utils.getBreakpoint.md`
        display: inherit;
        font-size: ${tokens.font.size.base};
    `}

  font-weight: ${fontWeight.book};

  ${(props) => (props.nestedStatus === "current" || props.nestedStatus === "completed") && css`
      color: ${tokens.colors.brand.snswPrimaryBlue};
    `}

  ${(props) => props.nestedStatus === "current" && css`
      font-weight: ${fontWeight.bold};
    `}

  ${(props) => props.nestedStatus === "todo" && css`
      color: ${colours.grey.shuttle};
    `}
`;
const SubSteps = styled.div`
  background-color: transparent !important;
  border: none !important;
  display: flex;
  flex-flow: column;
  align-items: center;
`;

const CheckIcon = () => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
      "path",
      {
        d: "M13.1747595,1.86431481 C13.7385965,1.18603191 14.7455336,1.09325516 15.4238165,1.65709213 C16.0597067,2.1856893 16.1809919,3.10372993 15.7290813,3.77530806 L15.6310392,3.9061491 L7.12750132,14.1357093 C6.569542,14.8069215 5.58639242,14.899104 4.91570423,14.3731823 L4.7859513,14.259745 L0.483650334,10.0759692 C-0.148689647,9.46104977 -0.162811756,8.4499462 0.45210772,7.81760622 C1.02859473,7.22478749 1.95329041,7.17532431 2.58765756,7.67813514 L2.71047074,7.78606361 L5.77496754,10.7656248 L13.1747595,1.86431481 Z",
        fill: "#fff"
      },
      void 0,
      false,
      {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
        lineNumber: 24,
        columnNumber: 5
      },
      globalThis
    )
  },
  void 0,
  false,
  {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
    lineNumber: 17,
    columnNumber: 3
  },
  globalThis
);
const Step = ({ steps, position, status }) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    ProgressStepperStep,
    {
      "data-testid-status": status,
      "data-testid": "progress-stepper-step",
      status,
      children: [
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
          StepPosition,
          {
            "data-testid-status": status,
            "aria-hidden": "true",
            status,
            children: position
          },
          void 0,
          false,
          {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
            lineNumber: 38,
            columnNumber: 7
          },
          globalThis
        ),
        /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(SubSteps, { children: steps.map(
          ({ content: nestedStepContent, status: nestedStepStatus }) => steps.every((step) => step.status === StepStatus.Completed) ? /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("section", { children: [
            /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
              StepPosition,
              {
                "data-testid-status": status,
                "aria-hidden": "true",
                status,
                children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(CheckIcon, {}, void 0, false, {
                  fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
                  lineNumber: 55,
                  columnNumber: 19
                }, globalThis)
              },
              void 0,
              false,
              {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
                lineNumber: 50,
                columnNumber: 17
              },
              globalThis
            ),
            /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
              StepLabel,
              {
                "data-testid": "progress-stepper-label",
                nestedStatus: nestedStepStatus,
                children: nestedStepContent
              },
              void 0,
              false,
              {
                fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
                lineNumber: 57,
                columnNumber: 17
              },
              globalThis
            )
          ] }, nestedStepContent, true, {
            fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
            lineNumber: 49,
            columnNumber: 15
          }, globalThis) : /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
            StepLabel,
            {
              "data-testid": "progress-stepper-label",
              nestedStatus: nestedStepStatus,
              children: nestedStepContent
            },
            nestedStepContent,
            false,
            {
              fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
              lineNumber: 65,
              columnNumber: 15
            },
            globalThis
          )
        ) }, void 0, false, {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
          lineNumber: 45,
          columnNumber: 7
        }, globalThis)
      ]
    },
    void 0,
    true,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/Step.tsx",
      lineNumber: 33,
      columnNumber: 5
    },
    globalThis
  );
};

const ProgressStepper = ({ stepsList, className }) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("div", { "data-testid": "progress-stepper", className, children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ProgressStepperList, { children: stepsList.map((step, index) => /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    Step,
    {
      steps: step.steps,
      position: index + 1,
      status: step.status
    },
    index,
    false,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/index.tsx",
      lineNumber: 54,
      columnNumber: 11
    },
    globalThis
  )) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/index.tsx",
    lineNumber: 52,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/progressStepper/index.tsx",
    lineNumber: 51,
    columnNumber: 5
  }, globalThis);
};

const { containers } = tokens.layouts;
const StyledSectionHeader = styled.header`
  background: ${colours.grey.iceBlue};
  padding: ${utils.getSpacing(["sm", "none"])};

  ${utils.getBreakpoint.md`
        padding: ${utils.getSpacing(["lg", "none", "md", "none"])};
    `}

  ${utils.getBreakpoint.print`
        padding: 0;
        background: 0;
    `}

    h1 {
    margin: 0;
    max-width: ${utils.pxToRem(768)};
  }

  p {
    margin-top: ${utils.getSpacing("xs")};
    margin-bottom: 0;
    max-width: ${utils.pxToRem(768)};
  }

  .notice:last-of-type {
    margin-bottom: 0;
  }

  @media print {
    .container {
      border-bottom: 2px solid ${colours.grey.geyser};
      padding: 0 0 25pt;
    }
  }

  .page-header__label {
    /* note :match PageLabel styles */
    font-size: ${utils.pxToRem(14)};
    line-height: ${tokens.font.lineHeight.heading};
  }
`;
const StyledFormHeader = styled(StyledSectionHeader)`
  padding: ${utils.getSpacing(["sm", "none", "sm", "none"])};

  ${utils.getBreakpoint.md`
        padding: ${utils.getSpacing(["md", "none", "md", "none"])};
    `}

  h1 {
    margin-top: ${utils.getSpacing("sm")};
    margin-bottom: 0;
    max-width: ${utils.pxToRem(768)};

    ${utils.getBreakpoint.md`
            margin-top: ${utils.getSpacing("md")};
        `}
  }

  p {
    margin: 0;
  }
`;
const Container = styled.div`
  max-width: ${utils.pxToRem(containers.maxWidth)};
  padding-left: ${utils.pxToRem(containers.gutters.mobile)};
  padding-right: ${utils.pxToRem(containers.gutters.mobile)};
  margin-left: auto;
  margin-right: auto;

  a {
    text-decoration: underline;
  }

  ${utils.getBreakpoint.md`
        padding-left: ${utils.pxToRem(containers.gutters.desktop)};
        padding-right: ${utils.pxToRem(containers.gutters.desktop)};
    `}

  ${utils.getBreakpoint.print`
        max-width: none;
        padding-left: 0;
        padding-right: 0;
        margin-left: 0;
        margin-right: 0
    `}
`;
const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px;
`;
const TitleContainer = styled.div`
  border-bottom: 2px solid ${colours.grey.geyser};

  margin-bottom: 2.5rem;
`;
const ContainerHeaderLeft = styled.div`
  color: ${colours.text.link};
`;
styled(Heading).attrs({ level: 1 })`
  + * {
    margin-top: ${utils.getSpacing("sm")};
    margin-bottom: 0;

    ${utils.getBreakpoint.md`
            margin-top: ${utils.getSpacing("xl")};
            margin-bottom: ${utils.getSpacing("md")};
        `}
  }
`;

const StepperHeader = ({
  label,
  entityName,
  clientId,
  referenceNumTitle,
  referenceNumVal
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledFormHeader, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ContainerHeader, { children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ContainerHeaderLeft, { children: [
      label && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: label }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
        lineNumber: 21,
        columnNumber: 21
      }, globalThis),
      entityName && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Heading, { level: 4, children: entityName }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
        lineNumber: 22,
        columnNumber: 26
      }, globalThis),
      clientId && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Heading, { level: 4, children: clientId }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
        lineNumber: 23,
        columnNumber: 24
      }, globalThis)
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
      lineNumber: 20,
      columnNumber: 9
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("div", { children: [
      referenceNumTitle && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("p", { children: referenceNumTitle }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
        lineNumber: 26,
        columnNumber: 33
      }, globalThis),
      referenceNumVal && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Heading, { level: 4, children: referenceNumVal }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
        lineNumber: 27,
        columnNumber: 31
      }, globalThis)
    ] }, void 0, true, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
      lineNumber: 25,
      columnNumber: 9
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
    lineNumber: 19,
    columnNumber: 7
  }, globalThis) }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/stepperHeader/index.tsx",
    lineNumber: 18,
    columnNumber: 5
  }, globalThis);
};

const ProgressStepperHeader = ({
  label,
  entityName,
  clientId,
  referenceNumTitle,
  referenceNumVal,
  className,
  stepsList
}) => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(StyledFormHeader, { className, children: [
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(TitleContainer, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Container, { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
      StepperHeader,
      {
        label,
        entityName,
        clientId,
        referenceNumTitle,
        referenceNumVal
      },
      void 0,
      false,
      {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
        lineNumber: 19,
        columnNumber: 11
      },
      globalThis
    ) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
      lineNumber: 18,
      columnNumber: 9
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
      lineNumber: 17,
      columnNumber: 7
    }, globalThis),
    /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Container, { children: stepsList && /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(ProgressStepper, { stepsList }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
      lineNumber: 29,
      columnNumber: 23
    }, globalThis) }, void 0, false, {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
      lineNumber: 28,
      columnNumber: 7
    }, globalThis)
  ] }, void 0, true, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/progressStepperHeader/index.tsx",
    lineNumber: 16,
    columnNumber: 5
  }, globalThis);
};

const documentSvg = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PScwIDAgMTYgMTYnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycgZmlsbD0iIzI0MjkzNCI+CiAgPHBhdGggZmlsbC1ydWxlPSdldmVub2RkJyBkPSdNMiAxLjFDMiAwLjQ5MjQ4OSAyLjQ5MjQ5IDkuNTM2NzRlLTA3IDMuMSA5LjUzNjc0ZS0wN0g5LjQxNDIxTDE0IDQuNTg1NzlWMTQuOUMxNCAxNS41MDc1IDEzLjUwNzUgMTYgMTIuOSAxNkgzLjFDMi40OTI0OCAxNiAyIDE1LjUwNzUgMiAxNC45VjEuMVpNNCAxNEgxMlY2SDkuMUM4LjQ5MjQ5IDYgOCA1LjUwNzUyIDggNC45VjJINFYxNFpNMTAgMy40MTQyMUwxMC41ODU4IDRMMTAuMjkyOSAzLjcwNzExTDEwIDMuNDE0MjFaJy8+Cjwvc3ZnPg==";

const Logo$1 = styled.img`
  height: ${pxToRem(16)};
  width: ${pxToRem(16)};
`;

const DocumentIcon = () => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Logo$1, { src: documentSvg, alt: "Document Icon" }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/documentIcon/index.tsx",
    lineNumber: 6,
    columnNumber: 10
  }, globalThis);
};

const info = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDE2LjAwMkMzLjU4MTcyIDE2LjAwMiAwIDEyLjQyMDIgMCA4LjAwMTk1QzAgMy41ODM2NyAzLjU4MTcyIDAuMDAxOTUzMTMgOCAwLjAwMTk1MzEyQzEyLjQxODMgMC4wMDE5NTMxMiAxNiAzLjU4MzY3IDE2IDguMDAxOTVDMTYgMTAuMTIzNyAxNS4xNTcxIDEyLjE1ODUgMTMuNjU2OSAxMy42NTg4QzEyLjE1NjYgMTUuMTU5MSAxMC4xMjE3IDE2LjAwMiA4IDE2LjAwMloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiA4LjAwMTk1QzIgMTEuMzE1NyA0LjY4NjI5IDE0LjAwMiA4IDE0LjAwMkM5LjU5MTMgMTQuMDAyIDExLjExNzQgMTMuMzY5OCAxMi4yNDI2IDEyLjI0NDZDMTMuMzY3OSAxMS4xMTk0IDE0IDkuNTkzMjUgMTQgOC4wMDE5NUMxNCA0LjY4ODI0IDExLjMxMzcgMi4wMDE5NSA4IDIuMDAxOTVDNC42ODYyOSAyLjAwMTk1IDIgNC42ODgyNCAyIDguMDAxOTVaTTAgOC4wMDE5NUMwIDEyLjQyMDIgMy41ODE3MiAxNi4wMDIgOCAxNi4wMDJDMTAuMTIxNyAxNi4wMDIgMTIuMTU2NiAxNS4xNTkxIDEzLjY1NjkgMTMuNjU4OEMxNS4xNTcxIDEyLjE1ODUgMTYgMTAuMTIzNyAxNiA4LjAwMTk1QzE2IDMuNTgzNjcgMTIuNDE4MyAwLjAwMTk1MzEyIDggMC4wMDE5NTMxMkMzLjU4MTcyIDAuMDAxOTUzMTIgMCAzLjU4MzY3IDAgOC4wMDE5NVpNOSAxMS4wMDJWOC4wMDE5NUM5IDcuNDQ5NjcgOC41NTIyOSA3LjAwMTk1IDggNy4wMDE5NUM3LjQ0NzcyIDcuMDAxOTUgNyA3LjQ0OTY3IDcgOC4wMDE5NVYxMS4wMDJDNyAxMS41NTQyIDcuNDQ3NzIgMTIuMDAyIDggMTIuMDAyQzguNTUyMjkgMTIuMDAyIDkgMTEuNTU0MiA5IDExLjAwMlpNOC4xOSA2LjAwMTk1QzguMjU2MjQgNS45OTI2OCA4LjMyMDQ1IDUuOTcyNCA4LjM4IDUuOTQxOTVDOC40NDE0MyA1LjkyMTk4IDguNDk4OTUgNS44OTE1MyA4LjU1IDUuODUxOTVDOC42MDcyMSA1LjgxNzQgOC42NjA4MSA1Ljc3NzIgOC43MSA1LjczMTk1QzguODk5MzEgNS41NDQxOSA5LjAwNTggNS4yODg1OSA5LjAwNTggNS4wMjE5NUM5LjAwNTggNC43NTUzMiA4Ljg5OTMxIDQuNDk5NzIgOC43MSA0LjMxMTk1QzguNDI2NDggNC4wMjYwMiA3Ljk5OTEyIDMuOTM4MDMgNy42MjU3MSA0LjA4ODdDNy4yNTIyOSA0LjIzOTM4IDcuMDA1NjggNC41OTkzMyA3IDUuMDAxOTVDNyA1LjU1NDI0IDcuNDQ3NzIgNi4wMDE5NSA4IDYuMDAxOTVIOC4xOVoiIGZpbGw9IiMyNDI5MzQiLz4KPC9zdmc+Cg==";

const Logo = styled.img`
  height: ${pxToRem(16)};
  width: ${pxToRem(16)};
`;

const IconInfo = () => {
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(Logo, { src: info }, void 0, false, {
    fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/iconInfo/index.tsx",
    lineNumber: 6,
    columnNumber: 10
  }, globalThis);
};

const { colors, spacing } = tokens;
const IconDelete = ({
  size = "sm",
  color = "darkGrey",
  ...props
}) => {
  const sizeArray = Object.entries(spacing.icons);
  const colorArray = Object.entries(colors.icons);
  const sizeOptions = new Map(sizeArray);
  const displaySize = sizeOptions.get(size);
  const colorOptions = new Map(colorArray);
  const displayColor = colorOptions.get(color);
  return /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
    "svg",
    {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      fill: color || displayColor,
      width: Number(displaySize),
      height: Number(displaySize),
      ...props,
      children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV("g", { children: /* @__PURE__ */ jsxDevRuntimeExports.jsxDEV(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.82036 1.29775C5.11309 0.517143 5.85933 0 6.69301 0H9.30701C10.1407 0 10.8869 0.517146 11.1797 1.29775L12.193 4H12.9866C12.9947 3.9999 13.0029 3.9999 13.0111 4H14C14.5523 4 15 4.44772 15 5C15 5.55228 14.5523 6 14 6H13.905L12.9961 15.0885C12.9871 15.1915 12.9625 15.29 12.9246 15.3816C12.8673 15.5207 12.7798 15.6431 12.671 15.7415C12.4893 15.9058 12.2483 16.0032 11.989 16H4.01105C3.9077 16.0013 3.80724 15.9865 3.7123 15.958C3.42636 15.872 3.19036 15.6605 3.07539 15.3816C3.03752 15.29 3.01289 15.1915 3.00386 15.0885L2.09501 6H2C1.44772 6 1 5.55228 1 5C1 4.44772 1.44772 4 2 4H2.98895C2.99713 3.9999 3.0053 3.9999 3.01344 4H3.807L4.82036 1.29775ZM4.47665 6C4.49215 6.00036 4.50762 6.00036 4.52305 6H11.477C11.4924 6.00036 11.5079 6.00036 11.5234 6H11.895L11.095 14H4.90499L4.10499 6H4.47665ZM10.057 4H5.94301L6.69301 2H9.30701L10.057 4Z"
        },
        void 0,
        false,
        {
          fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/IconDelete/index.tsx",
          lineNumber: 29,
          columnNumber: 9
        },
        globalThis
      ) }, void 0, false, {
        fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/IconDelete/index.tsx",
        lineNumber: 28,
        columnNumber: 7
      }, globalThis)
    },
    void 0,
    false,
    {
      fileName: "/builds/nsw-department-of-customer-service/nsw-dcs/nswrevenue/revenuedigital/payroll-tax/ams-portal-ui/packages/common/src/components/IconDelete/index.tsx",
      lineNumber: 19,
      columnNumber: 5
    },
    globalThis
  );
};

export { AMSButton, Breadcrumbs, DocumentIcon, EllipsisText, ErrorBoundary, ErrorSummary, FileUpload, GlobalStyleArp, HeadingItem, HideOnMobile, IconDelete, IconInfo, LabelDescriptionList, MatterAlert, MultiSelect, Navigation, PageTitle, ProgressHeader, ProgressStepperHeader, StepStatus as ProgressStepperStepStatus, RootLayout, ScrollToTop, ShowMore, ShowOnMobile, StepStatus$1 as StepStatus, StickyTable, StyledAMSContentContainer, StyledContentContainer$1 as StyledContentContainer, StyledHeaderContainer, StyledTableContainer, StyledTableHeader, Tooltip, WeightBold, WeightBook, WeightMedium, colours, container, device, fontSizes, fontType, fontWeight, formatDate, isNullOrEmpty, media, pxToRem, screenReaderOnlyStyle, spacing$1 as spacing };
//# sourceMappingURL=index.es.js.map
